document.addEventListener('DOMContentLoaded', function () {
  var columns_desktop = window.sectionSettings.columns_desktop;
  var columns_mobile = window.sectionSettings.columns_mobile;

  const swiper_collection = new Swiper('.multicolumn-list', {
    slidesPerView: columns_mobile,
    spaceBetween: 5,
    navigation: {                       
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
     640: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1300: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
      1524: {
        slidesPerView: columns_desktop,
        spaceBetween: 30,
      },     
    }
  });
});